module.exports = __webpack_public_path__ + "img/p67-zhengzhou-2017.2b2dae87.jpg";